import _ from 'lodash/fp'
import {formatDate, parseDate} from '@startlibs/utils'

export const DATE_FORMAT = () => "yyyy-MM-dd"
export const SESSION_EXPIRED_MSG = "Your session has expired due to inactivity. Please log in again."

export const getDateValue = (key,params) => params[key] ? parseDate(params[key],new Date(),"MM-dd-yyyy") : NaN
// export const getDateValue2 = (key,params) => params[key] ? new Date(params[key]) : NaN

export const getDate = (n) => {
  const date = new Date()
  date.setDate(date.getDate() + n)
  return date
}

export const getDateYear = (n) => {
  const date = new Date()
  date.setFullYear(date.getFullYear() + n)
  return date
}

export const formatDateNoUTC = (date,format,messages) => formatDate(date,format,messages,true)

export const createDateReformatter = (from, to) => (date) => formatDate(parseDate(date,new Date(),from),to)

export const getAllowedHttpUrl = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null

  try {
    const parsed = new URL(value, window.location.origin)

    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.href
    }
  } catch (error) {
    return null
  }

  return null
}

export const redirectToAllowedHttpUrl = (value) => {
  const allowedUrl = getAllowedHttpUrl(value)

  if (!allowedUrl) return false

  window.location.assign(allowedUrl)
  return true
}

export function calculateAge(birthday) { // birthday is a date
  var ageDifMs = Date.now() - birthday;
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}
